import React from "react";

const MarkerSmallSVG = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="19"
      fill="none"
      viewBox="0 0 14 19"
    >
      <path
        stroke="#000"
        d="M6.6 17l-.371.335.371.411.371-.41L6.6 17zm0 0l.371.335h0l.002-.002.003-.003.013-.015.049-.055.181-.208a37.694 37.694 0 002.595-3.397c.71-1.052 1.427-2.247 1.967-3.454.538-1.2.919-2.45.919-3.601a6.1 6.1 0 00-12.2 0c0 1.151.38 2.4.919 3.601.54 1.207 1.257 2.402 1.967 3.454a37.694 37.694 0 002.776 3.605l.05.055.012.015.003.004h.001c0 .001.001.001.372-.334zm1.386-9.826l.462.191-.462-.191a1.5 1.5 0 11-2.772-1.148 1.5 1.5 0 012.772 1.148z"
      ></path>
    </svg>
  );
};

export default MarkerSmallSVG;
